// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The scenario layers (#662) sit beside React Flow's renderer, whose z-index is
   4: frames and stand-in edges just under it, so nodes and edges draw over
   them; boxes and frame headers just over it. Both let pointer events through
   except where something in them takes them. */

.i_1iaJKUWMZ2c3lqayLn,
.LM5j4_cr_C3rLtS0HKtw {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.i_1iaJKUWMZ2c3lqayLn {
  z-index: 3;
}

.LM5j4_cr_C3rLtS0HKtw {
  z-index: 5;
}

/* Canvas coordinates: the viewport's own translate and scale. */
.Od_DPbXPnDcR_4A9lXf9 {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0 0;
}

.mi9lc3yVJv9agCi2SLvy {
  position: absolute;
  border: 2px dashed;
  border-radius: var(--curio-radius-lg);
}

.M5g011fLnnqa0l2gs5yz {
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: visible;
}

.FGiAIaKHSXKmnY_HaAlI {
  fill: none;
  stroke: var(--curio-text-secondary);
  stroke-width: 2;
  stroke-dasharray: 6 4;
}

.uyiwl2b90Db7WaJ79VXM {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
  white-space: nowrap;
}

.V1pfa9eCjwpAReLJdv4v {
  color: #fff;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  line-height: 20px;
  padding: 0 10px;
  border-radius: var(--curio-radius-pill);
}

.UltnegTTm4Whi7REgaXz {
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-xs);
  line-height: 18px;
  padding: 0 8px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-pill);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  cursor: pointer;
}

.UltnegTTm4Whi7REgaXz:hover {
  background: var(--curio-surface-muted);
}

.fpA7HYCUiskDrVb_6UBg {
  position: absolute;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: var(--curio-radius-lg);
  background: var(--curio-card-bg);
  box-shadow: var(--curio-shadow-browse-card-raised);
  font-family: var(--curio-font-family);
  color: var(--curio-text-primary);
  pointer-events: auto;
  cursor: grab;
  user-select: none;
}

.fpA7HYCUiskDrVb_6UBg:active {
  cursor: grabbing;
}

.hGXkoXgmSJkw90X9XHt5 {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 10px;
  color: #fff;
  border-radius: 5px 5px 0 0;
}

.iCkj9LmrafhK3lRNr5YU {
  font-size: var(--curio-font-size-lg);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.g4aSZrWEEiWjzuWdyUK7 {
  font-size: var(--curio-font-size-xs);
  opacity: 0.85;
  white-space: nowrap;
}

.gHkkZDjhdILCVaZoQcvo {
  position: absolute;
  left: 10px;
  right: 10px;
  height: 22px;
  line-height: 22px;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-secondary);
}

.j5iHi8Tv3lG7bXxVOeZu {
  position: absolute;
  left: 0;
  right: 0;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  font-size: var(--curio-font-size-sm);
}

.QdyDngnmR4BLgB9JbP9e {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.RB0PMF7yNIUIIfh0hBBh {
  font-size: var(--curio-font-size-xs);
  padding: 0 6px;
  border-radius: var(--curio-radius-pill);
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
}

.RB0PMF7yNIUIIfh0hBBh[data-tone="done"] {
  background: var(--curio-success-bg);
  color: var(--curio-success-text);
}

.RB0PMF7yNIUIIfh0hBBh[data-tone="error"] {
  background: var(--curio-danger-bg);
  color: var(--curio-danger-text);
}

.RB0PMF7yNIUIIfh0hBBh[data-tone="stale"] {
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}

/* A port: half outside the box's edge, where a stand-in edge ends. */
.ODzn5K4Dt6kdDtiJzp5C,
.nN3FtrNv4bG8rW5z0mP9 {
  position: absolute;
  top: 7px;
  width: 10px;
  height: 10px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 50%;
  background: var(--curio-card-bg);
}

.ODzn5K4Dt6kdDtiJzp5C {
  left: -6px;
}

.nN3FtrNv4bG8rW5z0mP9 {
  right: -6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/scenarios/ScenarioLayers.module.css"],"names":[],"mappings":"AAAA;;;+CAG+C;;AAE/C;;EAEE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,uCAAuC;EACvC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kDAAkD;EAClD,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;EACvC,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* The scenario layers (#662) sit beside React Flow's renderer, whose z-index is\n   4: frames and stand-in edges just under it, so nodes and edges draw over\n   them; boxes and frame headers just over it. Both let pointer events through\n   except where something in them takes them. */\n\n.behind,\n.front {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.behind {\n  z-index: 3;\n}\n\n.front {\n  z-index: 5;\n}\n\n/* Canvas coordinates: the viewport's own translate and scale. */\n.plane {\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform-origin: 0 0;\n}\n\n.frame {\n  position: absolute;\n  border: 2px dashed;\n  border-radius: var(--curio-radius-lg);\n}\n\n.edges {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 1px;\n  overflow: visible;\n}\n\n.standIn {\n  fill: none;\n  stroke: var(--curio-text-secondary);\n  stroke-width: 2;\n  stroke-dasharray: 6 4;\n}\n\n.frameHeader {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  pointer-events: auto;\n  white-space: nowrap;\n}\n\n.chip {\n  color: #fff;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  line-height: 20px;\n  padding: 0 10px;\n  border-radius: var(--curio-radius-pill);\n}\n\n.headerButton {\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-xs);\n  line-height: 18px;\n  padding: 0 8px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-pill);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  cursor: pointer;\n}\n\n.headerButton:hover {\n  background: var(--curio-surface-muted);\n}\n\n.box {\n  position: absolute;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: var(--curio-radius-lg);\n  background: var(--curio-card-bg);\n  box-shadow: var(--curio-shadow-browse-card-raised);\n  font-family: var(--curio-font-family);\n  color: var(--curio-text-primary);\n  pointer-events: auto;\n  cursor: grab;\n  user-select: none;\n}\n\n.box:active {\n  cursor: grabbing;\n}\n\n.boxHeader {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 10px;\n  color: #fff;\n  border-radius: 5px 5px 0 0;\n}\n\n.boxName {\n  font-size: var(--curio-font-size-lg);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.boxCount {\n  font-size: var(--curio-font-size-xs);\n  opacity: 0.85;\n  white-space: nowrap;\n}\n\n.section {\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  height: 22px;\n  line-height: 22px;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-secondary);\n}\n\n.row {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px;\n  font-size: var(--curio-font-size-sm);\n}\n\n.rowLabel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status {\n  font-size: var(--curio-font-size-xs);\n  padding: 0 6px;\n  border-radius: var(--curio-radius-pill);\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n}\n\n.status[data-tone=\"done\"] {\n  background: var(--curio-success-bg);\n  color: var(--curio-success-text);\n}\n\n.status[data-tone=\"error\"] {\n  background: var(--curio-danger-bg);\n  color: var(--curio-danger-text);\n}\n\n.status[data-tone=\"stale\"] {\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n\n/* A port: half outside the box's edge, where a stand-in edge ends. */\n.portIn,\n.portOut {\n  position: absolute;\n  top: 7px;\n  width: 10px;\n  height: 10px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 50%;\n  background: var(--curio-card-bg);\n}\n\n.portIn {\n  left: -6px;\n}\n\n.portOut {\n  right: -6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"behind": `i_1iaJKUWMZ2c3lqayLn`,
	"front": `LM5j4_cr_C3rLtS0HKtw`,
	"plane": `Od_DPbXPnDcR_4A9lXf9`,
	"frame": `mi9lc3yVJv9agCi2SLvy`,
	"edges": `M5g011fLnnqa0l2gs5yz`,
	"standIn": `FGiAIaKHSXKmnY_HaAlI`,
	"frameHeader": `uyiwl2b90Db7WaJ79VXM`,
	"chip": `V1pfa9eCjwpAReLJdv4v`,
	"headerButton": `UltnegTTm4Whi7REgaXz`,
	"box": `fpA7HYCUiskDrVb_6UBg`,
	"boxHeader": `hGXkoXgmSJkw90X9XHt5`,
	"boxName": `iCkj9LmrafhK3lRNr5YU`,
	"boxCount": `g4aSZrWEEiWjzuWdyUK7`,
	"section": `gHkkZDjhdILCVaZoQcvo`,
	"row": `j5iHi8Tv3lG7bXxVOeZu`,
	"rowLabel": `QdyDngnmR4BLgB9JbP9e`,
	"status": `RB0PMF7yNIUIIfh0hBBh`,
	"portIn": `ODzn5K4Dt6kdDtiJzp5C`,
	"portOut": `nN3FtrNv4bG8rW5z0mP9`
};
export default ___CSS_LOADER_EXPORT___;
